import { orderPromotionTypes } from 'tools/promotion'
import { errorTypes } from 'components/Error'

export const orderStatuses = {
  customerDraft: 0,
  storeDraft: 1,
  pending: 2,
  confirmed: 3,
  fulfilled: 4,
  cancelled: 6,
  readyForCollection: 9,
  enRoute: 10,
  unfulfilled: 11
}

export const deliveryStatuses = {
  unassigned: 0,
  pending: 1,
  assigned: 2,
  requestCancelled: 3,
  cancelled: 4,
  failed: 5,
  driverOnTheWay: 6,
  notRequired: 7,
  merchantUncontactable: 8,
  driverDelivered: 9
}

export const getOrderStatusErrorType = (orderStatus) => {
  switch (orderStatus) {
    case orderStatuses.confirmed:
      return errorTypes.orderHasBeenConfirmed
    case orderStatuses.fulfilled:
      return errorTypes.orderHasBeenFulfilled
    case orderStatuses.cancelled:
      return errorTypes.orderHasBeenCancelled
    default:
      return null
  }
}

export const analyseStoreOrder = (storeOrder) => {
  const { data = {} } = storeOrder
  // deliveryFreeAfter: 0 means there will be always deliveryFee (It actually means Infinity)
  const deliveryFreeAfter = data.deliveryFreeAfter === 0 ? Infinity : data.deliveryFreeAfter
  const hasDeliveryFee = !data.isPickup
  const reachedMinOrder = data.subtotal >= data.minimumOrder
  const reachedFreeDelivery = !hasDeliveryFee || data.remainingAmountToFreeDelivery === 0

  const deliveryPromotions = []
  const otherPromotions = []
  const minimumOrderOverridePromotions = []
  const beforeDeliveryCharges = []
  const otherCharges = []

  const orderPromotions = data.orderPromotions || []
  const taxAndCharges = data.taxAndCharges || []

  orderPromotions.forEach((promotion) => {
    if (promotion.type === orderPromotionTypes.deliveryOverride) {
      deliveryPromotions.push(promotion)
    } else if (promotion.type === orderPromotionTypes.minimumOrderOverride) {
      minimumOrderOverridePromotions.push(promotion)
    } else {
      otherPromotions.push(promotion)
    }
  })

  taxAndCharges.forEach((charge) => {
    // NOTE: API bug the value in isAppliedBeforeDelivery has reverse meaning (isAppliedBeforeDelivery: true means to be applied (shown) after delivery)
    if (charge.isAppliedBeforeDelivery) {
      otherCharges.push(charge)
    } else {
      beforeDeliveryCharges.push(charge)
    }
  })

  return {
    hasPromotions: data.orderPromotions && data.orderPromotions.length > 0,
    reachedMinOrder,
    amountToMinOrder: reachedMinOrder ? 0 : data.minimumOrder - data.subtotal,
    hasDeliveryFee,
    hasFreeDelivery: deliveryFreeAfter !== Infinity,
    reachedFreeDelivery,
    amountToFreeDelivery: data.remainingAmountToFreeDelivery,
    hasMinimumOrder: !!data.minimumOrder,
    deliveryPromotions,
    otherPromotions,
    minimumOrderOverridePromotions,
    beforeDeliveryCharges,
    otherCharges,
    deliveryCost: data.deliveryCost,
    paymentAmount: (data.storeOrderPaymentDetails || {}).paymentAmount
  }
}
